import config from '~/config';
import http from './http';

export const getLenders = async () => {
    try {
        const results = await http.get(`${config.urls.base}/lender`);

        if (results.errored) {
            throw new Error(results.error);
        }

        return results;

    } catch (err) {
        console.error(err);
        return [];
    }
};

export default {
    getLenders
};